import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { useUpdateEffect } from 'react-use';
import {
  type HSEdge,
  type HSIconImage,
  type HSIconSeqFrame,
  type HSIconSystem,
  HSIconType,
  type HSIconVideo,
} from '@types';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import { EDITING_ANCHOR } from '../constants';

const items: DropdownItem<HSEdge>[] = [
  { id: 'center', name: '正中心' },
  { id: 'topleft', name: '左上角' },
  { id: 'topright', name: '右上角' },
  { id: 'leftbottom', name: '左下角' },
  { id: 'rightbottom', name: '右下角' },
  { id: 'top', name: '顶部居中' },
  { id: 'bottom', name: '底部居中' },
  { id: 'left', name: '左侧居中' },
  { id: 'right', name: '右侧居中' },
];

type Icon = HSIconSystem | HSIconImage | HSIconSeqFrame | HSIconVideo;

const ID = 'hotspot_anchor';

function EdgeRow() {
  const { hotspot, isBatch, batchHotspots } = useStore($editingHotspot)!;
  const icon = hotspot.icon as Icon;

  const { ath, atv } = hotspot.icon;

  useEffect(() => {
    MainPlayer.get()?.addImageHotspot({
      id: ID,
      urls: [EDITING_ANCHOR],
      ath,
      atv,
      dragable: false,
      scaleX: 0.5,
      scaleY: 0.5,
      zOrder: 150,
    });
    return () => {
      MainPlayer.get()?.removeHotspotById(ID);
    };
  }, []);

  useUpdateEffect(() => {
    MainPlayer.get()?.updateImageHotspot({ id: ID, ath, atv });
  }, [ath, atv]);

  const handleChange = (type: HSEdge) => {
    $editingHotspotApi.update((draft) => {
      (draft.icon as Icon).edge = type;
    });
    const params = { id: hotspot.id, edge: type };
    if (!isBatch) {
      if (
        icon.type === HSIconType.system ||
        icon.type === HSIconType.seqFrame
      ) {
        MainPlayer.get()?.updateImageFrameHotspot(params);
      } else if (icon.type === HSIconType.image) {
        MainPlayer.get()?.updateImageHotspot(params);
      } else if (icon.type === HSIconType.video) {
        MainPlayer.get()?.updateVideoHotspot(params);
      }
    } else {
      (batchHotspots ?? []).forEach((item) => {
        if (
          icon.type === HSIconType.system ||
          icon.type === HSIconType.seqFrame
        ) {
          MainPlayer.get()?.updateImageFrameHotspot({ ...params, id: item.id });
        } else if (icon.type === HSIconType.image) {
          MainPlayer.get()?.updateImageHotspot({ ...params, id: item.id });
        } else if (icon.type === HSIconType.video) {
          MainPlayer.get()?.updateVideoHotspot({ ...params, id: item.id });
        }
      });
    }
  };

  return (
    <>
      <div className="mb-10">锚点：</div>
      <Dropdown items={items} selected={icon.edge} onChange={handleChange} />
    </>
  );
}

export default EdgeRow;
